import React from 'react';

import { daysUntilCutOff, getXmasImageForCase } from '../../../services/xmasService';
import { makeSafe } from '../../../services/cloudinaryService';

export default function ({ range, xmasCutOffDate }) {
  if (!range) return null;
  const daysTilXmas = daysUntilCutOff(xmasCutOffDate);
  const image = getXmasImageForCase(daysTilXmas, range);
  if(!image || !image.length) return null;
  return (
    <div className="c-xmas-banner">
      <img alt="" src={makeSafe(image)} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/cards/templates/RangeDisplayCard/XmasBanner.js